<svg class="icon-svg" [class.grunge]="grungeSeed()" [style.--grunge-mask-url]="grungeMaskUrl()"
     xmlns="http://www.w3.org/2000/svg">
    <use [attr.xlink:href]="'#' + name()"></use>
</svg>
